module.exports = __webpack_public_path__ + "img/downloadsLeft.2d659610.svg";